export default "__VITE_ASSET__CDqjFX1c__"